var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn', ("btn-" + _vm.type), _vm.size !== undefined? ("btn-" + _vm.size):'', {'rounded':_vm.rounded},{'edgy':_vm.edgy}, {'still':_vm.still}],on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }